import { FGCustomInput, FGSelectInput, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import { FilePond } from "react-filepond";

import { FGPeopleSearchInput } from "../../../../../components";
import { useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IDrupalCompetitionClubSelectionProps {
  clubReadOnly: boolean;
  clubId: number;
  clubs: any;
  cloading: boolean;
}

export const DrupalCompetitionClubSelection: React.FunctionComponent<IDrupalCompetitionClubSelectionProps> = ({
  clubReadOnly,
  clubId,
  clubs,
  cloading,
}) => {
  const { t } = useTl();
  return (
    <>
      <FieldGroup columns={2}>
        <FGSelectInput
          name="clubId"
          readonly={clubReadOnly}
          label={t(ETLCodes.Club)}
          items={clubs}
          loading={cloading}
        />
      </FieldGroup>
      <FieldGroup columns={2}>
        <FGPeopleSearchInput
          name="request.personId"
          label={t(ETLCodes.Contact)}
          clubId={clubId ?? -1}
          disabled={!clubId}
          requiredMark
        />
      </FieldGroup>
      <FieldGroup columns={2}>
        <FGTextInput name="clubEmail" label={t(ETLCodes.ClubEmail)} />
      </FieldGroup>
    </>
  );
};
